import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import { STLogo, STLogoTertiary } from 'components/Brand/Logos/STLogo';
import { HeaderLogoContainer } from './styles';

const HeaderLogo = ({ route, type, ...otherProps }) => {
  const logos = (
    <>
      <span style={{ display: 'none' }}>Logo</span>
      <STLogo type={type} className="header-logo--img white-logo" />
      <STLogoTertiary type={type} className="header-logo--img tertiary-logo" />
    </>
  );

  return (
    <HeaderLogoContainer {...otherProps} className="header-logo-container">
      {route ? (
        <HyperLink data-position="Header - Logo CTA" href={route}>
          {logos}
        </HyperLink>
      ) : (
        <div>{logos}</div>
      )}
    </HeaderLogoContainer>
  );
};

export default HeaderLogo;
